export enum ShipStatusEnum {
  LOADED = 0,
  IN_TRANSIT = 1,
  ARRIVED = 2,
  ABSENT_CLIENT = 3,
  DELIVERED = 4,
  RECOLECTED = 5,
  LANDING = 6,
  PENDING = 7,
  START_NAVIGATE = 8,
  NOTIFY_CLIENT = 9
}
